import acousticSlatOak from "@/assets/products/acoustic-slat-oak.jpg";
import acousticSlatWalnut from "@/assets/products/acoustic-slat-walnut.jpg";

import acousticFeltNavy from "@/assets/products/acoustic-felt-navy.jpg";
import acousticNaturalOakMain from "@/assets/products/acoustic-natural-oak-main.webp";
import acousticNaturalOakInstalled from "@/assets/products/acoustic-natural-oak-installed.webp";

import acousticWalnutTexture from "@/assets/products/acoustic-walnut-texture.jpg";
import acousticWalnutProduct from "@/assets/products/acoustic-walnut-product.jpg";
import acousticWalnutInstalled from "@/assets/products/acoustic-walnut-installed.jpg";

// New uploaded images
import acousticCharcoalTexture from "@/assets/products/acoustic-charcoal-texture.jpg";
import acousticCharcoalRoom from "@/assets/products/acoustic-charcoal-room.png";

import acousticNaturalOakTexture from "@/assets/products/acoustic-natural-oak-texture.jpg";
import acousticNaturalOakRoom from "@/assets/products/acoustic-natural-oak-room.webp";
import acousticWalnutRoom from "@/assets/products/acoustic-walnut-room.jpg";
import acousticWalnutTexture2 from "@/assets/products/acoustic-walnut-texture-2.jpg";
import acousticWhiteOakMirror from "@/assets/products/acoustic-white-oak-mirror.jpg";
import acousticWhiteOakRoom from "@/assets/products/acoustic-white-oak-room.jpg";
import acousticWhiteOakWhiteFeltTexture from "@/assets/products/acoustic-white-oak-white-felt-texture.jpg";
import acousticWhiteOakWhiteFeltRoom from "@/assets/products/acoustic-white-oak-white-felt-room.png";
import acousticWideCharcoalTexture from "@/assets/products/acoustic-wide-charcoal-texture.jpg";
import acousticWideCharcoalRoom from "@/assets/products/acoustic-wide-charcoal-room.webp";
import acousticWideLightWalnutTexture from "@/assets/products/acoustic-wide-light-walnut-texture.jpg";
import acousticWideLightWalnutRoom from "@/assets/products/acoustic-wide-light-walnut-room.jpg";
import americanWalnutAsset from "@/assets/products/acoustic-american-walnut.webp.asset.json";
import washedOakAsset from "@/assets/products/acoustic-washed-oak.webp.asset.json";

// Use the site's own canonical asset origin: the local Vite preview does not
// proxy /__l5e/assets-v1/ and otherwise returns its HTML fallback for images.
const assetUrl = (url: string) => `https://supremeturf.com.au${url}`;

export interface AcousticCladdingProduct {
  id: string;
  name: string;
  width: string;
  height: string;
  thickness: string;
  felt: string;
  price: number;
  priceUnit: string;
  image: string;
  images?: string[];
  description: string;
  colour: string;
  shopifyVariantId?: string;
  soldOut?: boolean;
}

export const ACOUSTIC_CLADDING_PRODUCTS: AcousticCladdingProduct[] = [
  {
    id: "ac-american-walnut",
    name: "American Walnut Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: assetUrl(americanWalnutAsset.url),
    images: [assetUrl(americanWalnutAsset.url)],
    colour: "American Walnut",
    description: "American walnut-look acoustic slat panel with black felt backing for interior feature walls. Available in Queensland and South Australia.",
  },
  {
    id: "ac-washed-oak",
    name: "Washed Oak Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: assetUrl(washedOakAsset.url),
    images: [assetUrl(washedOakAsset.url)],
    colour: "Washed Oak",
    description: "Washed oak-look acoustic slat panel with black felt backing for interior feature walls. Available in Queensland and South Australia.",
  },
  {
    id: "ac-natural-oak",
    name: "Natural Oak Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticNaturalOakMain,
    images: [acousticNaturalOakMain, acousticNaturalOakInstalled, acousticNaturalOakTexture, acousticNaturalOakRoom],
    colour: "Natural Oak",
    description: "Classic natural oak slat finish with black felt backing. Perfect for warm, timber-inspired interiors.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838591746289",
  },
  {
    id: "ac-charcoal",
    name: "Charcoal Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticCharcoalTexture,
    images: [acousticCharcoalTexture, acousticCharcoalRoom],
    colour: "Charcoal",
    description: "Bold charcoal slat finish with black felt. Ideal for modern, moody feature walls and home theatres.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838592139505",
  },
  {
    id: "ac-white-oak-black",
    name: "White Oak Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticSlatOak,
    images: [acousticSlatOak, acousticWhiteOakMirror, acousticWhiteOakRoom],
    colour: "White Oak",
    description: "Light white oak finish with black felt backing for a contemporary Scandinavian aesthetic.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838598627569",
  },
  {
    id: "ac-walnut",
    name: "Walnut Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticWalnutTexture,
    images: [acousticWalnutTexture, acousticWalnutTexture2, acousticWalnutProduct, acousticWalnutInstalled, acousticWalnutRoom],
    colour: "Walnut",
    description: "Rich walnut slat finish with black felt backing. Adds warmth and luxury to any interior space.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838598889713",
  },
  {
    id: "ac-wide-light-walnut",
    name: "Wide Light Walnut Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "18mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticWideLightWalnutTexture,
    images: [acousticWideLightWalnutTexture, acousticWideLightWalnutRoom, acousticWalnutRoom],
    colour: "Wide Light Walnut",
    description: "Wide-format light walnut panels with black felt — a modern take on classic timber cladding.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838598955249",
  },
  {
    id: "ac-wide-charcoal",
    name: "Wide Charcoal Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "18mm",
    felt: "Black",
    price: 75,
    priceUnit: "panel",
    image: acousticWideCharcoalTexture,
    images: [acousticWideCharcoalTexture, acousticWideCharcoalRoom],
    colour: "Wide Charcoal",
    description: "Wide-format charcoal slat panels with black felt backing — bold, architectural statement walls.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838599119089",
  },
  {
    id: "ac-white-oak-white",
    name: "White Oak (White Felt) Acoustic Cladding",
    width: "600mm",
    height: "2700mm",
    thickness: "21mm",
    felt: "White",
    price: 75,
    priceUnit: "panel",
    image: acousticWhiteOakWhiteFeltTexture,
    images: [acousticWhiteOakWhiteFeltTexture, acousticWhiteOakWhiteFeltRoom],
    colour: "White Oak (White Felt)",
    description: "White oak slat finish with matching white felt — ultra-clean and minimal for bright, airy rooms.",
    shopifyVariantId: "gid://shopify/ProductVariant/47838601347313",
  },
];

// The storefront accepts order requests from locally catalogued products too;
// do not fabricate a Shopify variant ID for finishes that have none.
export function acousticVariantId(product: AcousticCladdingProduct): string {
  return product.shopifyVariantId ?? `local-acoustic-variant-${product.id}`;
}
